import { PartnerRefAngebotBeziehungRollen } from '@mng/sales-types';
import { IRollenFeatures } from './antrag-fragen';

export const lvRollenFeatures: IRollenFeatures[] = [
  {
    rolle: PartnerRefAngebotBeziehungRollen.VERSICHERUNGSNEHMER,
    fragenDefs: {
      gesundheitsfragenG: new Set(),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: false,
      geldwaesche: true,
      sensibleDaten: true,
      bezugsrechtErleben: true,
      bezugsrechtAbleben: true,
      bezugsrechtKrankheit: true,
      paragraph_3_1_15: true,
      treuhaenderFrage: true,
      arbeitsStatusFrage: true,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: true,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: true,
      adresse: true,
      nationalitaet: true,
      erhaltbasisInfoBlatt: true
    }
  },
  {
    rolle: PartnerRefAngebotBeziehungRollen.VERSICHERUNGSNEHMER_2,
    fragenDefs: {
      gesundheitsfragenG: new Set(),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: false,
      geldwaesche: true,
      sensibleDaten: false,
      bezugsrechtErleben: false,
      bezugsrechtAbleben: false,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: true,
      arbeitsStatusFrage: true,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: true,
      veranlagungBeratung: false,
      schriftformDatennutzung: false,
      bestattung: false,
      familienstand: true,
      geburtsland: true,
      berufsinfo: true,
      sozialVersDaten: true,
      adresse: true,
      nationalitaet: true
    }
  },
  {
    rolle: PartnerRefAngebotBeziehungRollen.VERSICHERTE_PERSON_1,
    fragenDefs: {
      gesundheitsfragenG: new Set(),
      gesundheitsfragenCTFS: true,
      gesundheitsfragen: true,
      geldwaesche: false,
      sensibleDaten: true,
      bezugsrechtErleben: false,
      bezugsrechtAbleben: false,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: false,
      arbeitsStatusFrage: false,
      identifikationsnachweis: false,
      crsRelevant: false,
      fatcaGMSG: false,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: false,
      geburtsland: false,
      berufsinfo: true,
      sozialVersDaten: true,
      adresse: false,
      nationalitaet: false
    }
  },
  {
    rolle: PartnerRefAngebotBeziehungRollen.VERSICHERTE_PERSON_2,
    fragenDefs: {
      gesundheitsfragenG: new Set(),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: true,
      geldwaesche: false,
      sensibleDaten: true,
      bezugsrechtErleben: false,
      bezugsrechtAbleben: false,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: false,
      arbeitsStatusFrage: false,
      identifikationsnachweis: false,
      crsRelevant: false,
      fatcaGMSG: false,
      veranlagungBeratung: false,
      schriftformDatennutzung: true,
      bestattung: false,
      familienstand: false,
      geburtsland: false,
      berufsinfo: true,
      sozialVersDaten: true,
      adresse: false,
      nationalitaet: false
    }
  },
  {
    rolle: PartnerRefAngebotBeziehungRollen.PRAEMIENZAHLER,
    fragenDefs: {
      gesundheitsfragenG: new Set(),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: false,
      geldwaesche: true,
      sensibleDaten: false,
      bezugsrechtErleben: false,
      bezugsrechtAbleben: false,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: false,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: false,
      fatcaGMSG: false,
      veranlagungBeratung: false,
      schriftformDatennutzung: false,
      bestattung: false,
      familienstand: false,
      geburtsland: true,
      berufsinfo: false,
      sozialVersDaten: true,
      adresse: true,
      nationalitaet: true
    }
  },
  {
    rolle: PartnerRefAngebotBeziehungRollen.GESETZLICHER_VERTRETER,
    fragenDefs: {
      gesundheitsfragenG: new Set(),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: false,
      geldwaesche: false,
      sensibleDaten: false,
      bezugsrechtErleben: false,
      bezugsrechtAbleben: false,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: false,
      arbeitsStatusFrage: false,
      identifikationsnachweis: true,
      crsRelevant: true,
      fatcaGMSG: false,
      veranlagungBeratung: false,
      schriftformDatennutzung: false,
      bestattung: false,
      familienstand: false,
      geburtsland: true,
      berufsinfo: false,
      sozialVersDaten: true,
      adresse: true,
      nationalitaet: true
    }
  },
  {
    rolle: PartnerRefAngebotBeziehungRollen.TREUGEBER,
    fragenDefs: {
      gesundheitsfragenG: new Set(),
      gesundheitsfragenCTFS: false,
      gesundheitsfragen: false,
      geldwaesche: false,
      sensibleDaten: false,
      bezugsrechtErleben: false,
      bezugsrechtAbleben: false,
      bezugsrechtKrankheit: false,
      paragraph_3_1_15: false,
      treuhaenderFrage: false,
      arbeitsStatusFrage: false,
      identifikationsnachweis: false,
      crsRelevant: false,
      fatcaGMSG: false,
      veranlagungBeratung: false,
      schriftformDatennutzung: false,
      bestattung: false,
      familienstand: false,
      geburtsland: true,
      berufsinfo: false,
      sozialVersDaten: true,
      adresse: true,
      nationalitaet: true
    }
  }
];
